window.addEventListener('load', event => {
    const stripeFormPanel = document.querySelectorAll('.stripe-donation-header-panel')

    if (stripeFormPanel.length) {
        document.addEventListener('click', (event) => {
            const target = event.target;

            // Handle showing of forms in multipage form panels
            if (target.matches('[data-toggle-form-index]') || target.parentElement?.matches('[data-toggle-form-index]')) {
                const showFormContainer = target.closest('[data-show-form-index]');
                const toggleFormIndex = target.dataset.toggleFormIndex;

                if (showFormContainer && toggleFormIndex) {
                    showFormContainer.dataset.showFormIndex = toggleFormIndex;
                }
            }
        });
    }
});

